import { useSelector } from 'react-redux';

import { dateFormat } from 'common/helpers/dateHelper';

import { isUpcomingHold, nextHold } from '../../helpers';

const HoldMessage = (props) => {
  const { clubMembership } = props;
  const settings = useSelector((state) => state.setting);

  const isFuture = isUpcomingHold(clubMembership);
  if (isFuture) {
    const uHold = nextHold(clubMembership);
    return (
      <>
        Your club will be on hold on {dateFormat(uHold.holdStartDate, settings)}
        .
        <br />
      </>
    );
  }
  return null;
};

export default HoldMessage;
